// src/Log.js
import React, { useState, useEffect } from 'react';
import './Log.css';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from './firebase';
import { format } from 'date-fns';

function Log() {
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 3;

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const logsRef = collection(db, 'issues');
        const q = query(logsRef, orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        const fetchedLogs = [];
        querySnapshot.forEach((doc) => {
          fetchedLogs.push({ id: doc.id, ...doc.data() });
        });
        setLogs(fetchedLogs);
      } catch (error) {
        console.error('Error fetching logs: ', error);
      }
    };

    fetchLogs();
  }, []);
  const totalPages = Math.ceil(logs.length / logsPerPage);

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog);

  return (
    <div className="log-container">
      <h2 className="log-title">Log of Issues</h2>
      <div className="log-list">
        {currentLogs.length > 0 ? (
          currentLogs.map((log) => {
            const formattedDate = format(
              log.dateResolved
                ? new Date(log.dateResolved)
                : new Date(log.dateReported),
              'MMM dd, yyyy'
            );
            return (
              <div key={log.id} className="log-card">
                <div className="log-header">
                  <span className="log-theater-seat">
                    Theater {log.theaterNumber}, Seat {log.seatNumber}
                  </span>
                  <span className="log-date">{formattedDate}</span>
                </div>
                <div className="log-comment">
                  {log.comment}
                  {log.resolved && (
                    <>
                      <br />
                      <strong>Resolved:</strong> {log.commentResolved}
                    </>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <p>No logs available.</p>
        )}
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Log;
